import React from 'react';
import PropTypes from 'prop-types';
import Popup from 'reactjs-popup';
import { connect } from 'react-redux';
import { UsersSelectors } from '../../../../Redux/modules/users/selectors';
import { UploadUserListStages } from '../../constants';
import styles from './UploadUsersListContainer.module.less';
import WelcomeModal from './WelcomeModal';
import UploadCSVModal from './UploadCSVModal';
import ValidateCSVModal from './ValidateCSVModal';
import ProgressBarModal from './ProgressBarModal';
import SuccessModal from './SuccessModal';
import { UsersActions } from '../../../../Redux/modules/users/actions';
import { AppSelectors } from '../../../../Redux/modules/app/selectors';

const UploadUsersListContainer = (props) => {
  const getModalStyle = () => {
    return {
      width: '530px',
      boxShadow: 'rgba(101, 101, 101, 0.28) 0px 4px 12px 0px',
      border: 'none',
      borderRadius: '8px',
      padding: '40px 80px',
      backgroundColor: '#ffffff',
    };
  };

  const onCloseSuccessModal = () => {
    props.closeSuccessModal();
  };

  const renderModalBody = (stage) => {
    const stageToComponentMapper = {
      [UploadUserListStages.WELCOME]: <WelcomeModal clickGetStarted={props.clickGetStarted} />,
      [UploadUserListStages.UPLOAD_CSV]: (
        <UploadCSVModal uploadedCSV="users-list.csv" validateCsvFile={props.validateCsvFile} />
      ),
      [UploadUserListStages.VALIDATE_CSV]: <ValidateCSVModal availableSubscriptions={props.availableSubscriptions} />,
      [UploadUserListStages.PROGRESS_BAR]: <ProgressBarModal />,
      [UploadUserListStages.SUCCESS]: <SuccessModal userEmail={props.userEmail} onClose={onCloseSuccessModal} />,
    };

    return stageToComponentMapper[stage];
  };

  return (
    <>
      <Popup
        contentStyle={getModalStyle()}
        modal
        open={props.open}
        onClose={() => {
          props.onClose();
        }}
        closeOnDocumentClick={false}
      >
        {() => {
          return (
            <>
              <span
                tabIndex={0}
                role="button"
                className={styles.close}
                onClick={() => {
                  props.onClose();
                }}
                id="cancel-button"
              >
                &times;
              </span>
              {renderModalBody(props.uploadUsersListStage)}
            </>
          );
        }}
      </Popup>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    uploadUsersListStage: UsersSelectors.uploadUsersListStageSelector(state),
    validUsers: UsersSelectors.validUsersInUploadSelector(state),
    userEmail: AppSelectors.emailSelector(state),
  };
};

const mapDispatchToProps = {
  clickGetStarted: UsersActions.clickGetStartedUploadUserList,
  validateCsvFile: UsersActions.validateCsvFile,
  finishProgress: UsersActions.switchStageToSuccess,
  closeSuccessModal: UsersActions.closeSuccessModal,
};

UploadUsersListContainer.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  uploadUsersListStage: PropTypes.string,
  clickGetStarted: PropTypes.func,
  validateCsvFile: PropTypes.func,
  availableSubscriptions: PropTypes.number,
  closeSuccessModal: PropTypes.func,
  userEmail: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadUsersListContainer);
